import { RemoteComponentContext } from "@bookingcom/remote-component";
import React from "react";
const RemoteComponentExperiment = (props) => {
    const { value, children } = props;
    if (!value)
        return React.createElement(React.Fragment, null, children);
    return React.createElement(RemoteComponentContext.Provider, { value: value }, children);
};
export default RemoteComponentExperiment;
